var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22633_126520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22633_126520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 24.5C5.19167 24.5 4.64236 24.2715 4.18542 23.8146C3.72847 23.3576 3.5 22.8083 3.5 22.1667V5.83333C3.5 5.19167 3.72847 4.64236 4.18542 4.18542C4.64236 3.72847 5.19167 3.5 5.83333 3.5H19.8333L24.5 8.16667V14.35C24.1306 14.1944 23.7465 14.0924 23.3479 14.0438C22.9493 13.9951 22.5556 14 22.1667 14.0583V9.12917L18.8708 5.83333H5.83333V22.1667H12.8333V24.5H5.83333ZM15.1667 26.8333V23.2458L21.6125 16.8292C21.7875 16.6542 21.9819 16.5278 22.1958 16.45C22.4097 16.3722 22.6236 16.3333 22.8375 16.3333C23.0708 16.3333 23.2944 16.3771 23.5083 16.4646C23.7222 16.5521 23.9167 16.6833 24.0917 16.8583L25.1708 17.9375C25.3264 18.1125 25.4479 18.3069 25.5354 18.5208C25.6229 18.7347 25.6667 18.9486 25.6667 19.1625C25.6667 19.3764 25.6278 19.5951 25.55 19.8188C25.4722 20.0424 25.3458 20.2417 25.1708 20.4167L18.7542 26.8333H15.1667ZM16.9167 25.0833H18.025L21.5542 21.525L21.0292 20.9708L20.475 20.4458L16.9167 23.975V25.0833ZM21.0292 20.9708L20.475 20.4458L21.5542 21.525L21.0292 20.9708ZM7 11.6667H17.5V7H7V11.6667ZM14 21H14.1167L17.5 17.6458V17.5C17.5 16.5278 17.1597 15.7014 16.4792 15.0208C15.7986 14.3403 14.9722 14 14 14C13.0278 14 12.2014 14.3403 11.5208 15.0208C10.8403 15.7014 10.5 16.5278 10.5 17.5C10.5 18.4722 10.8403 19.2986 11.5208 19.9792C12.2014 20.6597 13.0278 21 14 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproverIcon);
export default __webpack_public_path__ + "static/media/Approver_icon.05be6f78024e05fa23454dbbc05e3830.svg";
export { ForwardRef as ReactComponent };